/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';

import { Sttp } from '@common/sttp';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { vappContainer } from '@/application';

export interface ISignInUserProps {
  email?: string;
  password?: string;
  otp?: string;
  jwtToken?: string;
  role?: string;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface ISignInUserMethods extends IPluginMethodMap {
  getSignInUserProps(args: ISignInUserProps): Promise<any>;
}

export interface ISignInUserMethods extends IPluginMethodMap {
  getSignInUserProps(args: ISignInUserProps): Promise<any>;
}

export class SignInUserPlugin implements IAgentPlugin {
  readonly methods: ISignInUserMethods;

  constructor() {
    this.methods = {
      getSignInUserProps: this.getProps.bind(this),
    };
  }

  async getProps(args: ISignInUserProps) {
    console.log(`args send otp`, args);
    return await this.SignInUser(args);
  }

  private async SignInUser(args: ISignInUserProps) {
    try {
      let sttp = Sttp.withBaseUrl(apiConfig.rest.url);
      //  sttp =  sttp
      //     .withQueryParams({ page: 3 })
      //     .withHeaders({ 'X-API-Token': 123 })
      //     .withPayload({ name: 'Supercharge' })
      // const res = await sttp.post(`/your_url`);

      const res = await sttp.post(apiConfig?.SignInUserEP, {
        ...args,
      });
      if (res?.isError()) {
        log.error(
          `error in post status=${res.status()} statusText=${res.statusText()}`
        );
      }
      log.log('result of post=', res.data());
      return res.data();
    } catch (err: any) {
      log.error('error in post=', err?.message);
      throw err;
    }
  }
}
